// calculate header height and add it in a variable
function setHeaderHeightVariable() {
  var headerContainer = document.querySelector('#shopify-section-header .header-sticky-wrapper');
  
  if (headerContainer) {
    //var totalHeight = headerContainer.getBoundingClientRect().height;
    var totalHeight = headerContainer.offsetHeight;
    document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
  }
}

// Call the function on page load and on window resize
window.addEventListener('load', setHeaderHeightVariable);
//window.addEventListener('resize', setHeaderHeightVariable);